import type { CheckoutCoupon } from '~/type/Checkout'
export function CheckoutCouponSerializer(el: { [key: string]: any } = {}): CheckoutCoupon {
  return {
    coupon: el.COUPON,
    description: el.DISCOUNT_NAME,
    status: el.STATUS_TEXT,
  }
}
